import { Injectable } from '@angular/core';
import { GenericLambdaReturn, DateFilter } from '../models/partsWarehouse';
import { PartsServiceUtil } from './parts.service.util';
import { AbstractRestService } from './abstract.rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PutawayMetricService extends AbstractRestService{

  dfCompare( a: DateFilter, b: DateFilter): boolean {
    console.log("dfCompare",a,b);
    if (!(a||b)) return true;
    if (! a&&b ) return false;
    return !(a.start === b.start && a.end===b.end);
  }

  getLPNCounts(siteId: string, df: DateFilter, hour?: number):Observable<GenericLambdaReturn<PutAwayData[]>> {
    return this.get('/putawaymetric', PartsServiceUtil.buildParams(siteId, df, null, null, hour));
  }
}

export type PutAwayData = {
  SSO: string;
  Name: string;
  Total: string;
  Override: number;
  pctIncorrect: number;
}